import { AccessTime, Cached, SvgIconComponent } from '@mui/icons-material'
import { Chip, ChipProps, Tooltip } from '@mui/material'
import { useIsThemeV2 } from '@omnea-app/omui/NewThemeProvider'
import { AMENDMENT_STATE_COLOR, AmendmentState } from './amendmentStates'

const STATE_ICON: Record<AmendmentState, SvgIconComponent> = {
  'awaiting-change': AccessTime,
  'change-required': Cached,
  'change-actioned': Cached,
  changed: Cached,
}

// Theme v1 chips lack the info/neutral colours (info→primary, neutral→default); dies with v1.
const CHIP_COLOR_V1: Record<AmendmentState, ChipProps['color']> = {
  'awaiting-change': 'primary',
  'change-required': 'warning',
  'change-actioned': 'default',
  changed: 'warning',
}

type AmendmentStateChipProps = {
  state: AmendmentState
  label: string
  tooltipLabel?: string
  iconSx?: ChipProps['sx']
  sx?: ChipProps['sx']
  'data-testid'?: string
}

// The amendment chip every surface delegates to — icon and colour are bound to the state here,
// so surfaces only supply their own copy.
export const AmendmentStateChip = ({
  state,
  label,
  tooltipLabel,
  iconSx,
  sx,
  'data-testid': dataTestId,
}: AmendmentStateChipProps) => {
  const isThemeV2 = useIsThemeV2()
  const Icon = STATE_ICON[state]
  const chip = (
    <Chip
      size="small"
      label={label}
      icon={<Icon sx={iconSx} />}
      color={isThemeV2 ? AMENDMENT_STATE_COLOR[state] : CHIP_COLOR_V1[state]}
      data-testid={dataTestId}
      data-amendment-state={state}
      sx={sx}
    />
  )
  return tooltipLabel == null ? chip : <Tooltip title={tooltipLabel}>{chip}</Tooltip>
}
